jQuery(document).ready(function () {
  // Swiper: Slider
  new Swiper(".sf-testimonials__container .swiper-container", {
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next", // or your actual arrow class
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 5,
    // paginationClickable: true,
    // centeredSlides: true,
    spaceBetween: 10,
    // autoplay: 5000,
    breakpoints: {
      990: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });

  // Equalize heights
  function equalizeHeights() {
    const slides = document.querySelectorAll(".sf-testimonials__container .swiper-slide");
    let maxHeight = 0;
    slides.forEach(slide => {
      slide.style.height = "auto"; // reset first
      maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });
    slides.forEach(slide => {
      slide.style.height = maxHeight + "px";
    });
  }

  equalizeHeights();
  window.addEventListener("resize", equalizeHeights);

});
